@if (test) {
	<div [dir]="test.lang === 'en' ? 'ltr' : 'rtl'">
		<div class="testanswer-fill">
			<ng-container
				*ngTemplateOutlet="rowFields; context: { test: test, patient: patient }"
			></ng-container>

			@for (subtest of test.tests; track subtest) {
				<ng-container
					*ngTemplateOutlet="rowFields; context: { test: subtest }"
				></ng-container>
			}
		</div>
		<div class="d-flex gap-3 pt-5 testanswer-fill">
			@if (test?.user_sign_required == "yes") {
				<div>
					<label>{{ "user_signature" | langVal }}</label>

					<div>
						<app-canvas-write
							(imageOutput)="user_sign_img_blob = $event; validateEntireForm()"
							[error]="userSignErr"
						/>
					</div>
				</div>
			}
			@if (test?.patient_sign_required == "yes") {
				<div>
					<label>{{ "patient_signature" | langVal }}</label>

					<div>
						<app-canvas-write
							(imageOutput)="
								patient_sign_img_blob = $event; validateEntireForm()
							"
							[error]="patientSignErr"
						/>
					</div>
				</div>
			}
		</div>
	</div>
	<div class="modal-btns">
		@if (!isFormSubmittable) {
			<div
				class="error"
				style="color: var(--green)"
			>
				{{ "not_all_questions_answered" | langVal }}
			</div>
		}
		<div class="d-flex gap-1 mis-auto">
			@if (isModalMode) {
				<app-cancel-btn (click)="onClose.emit()" />
			}
			@if (patient) {
				<app-btn-ext
					text="create_scheduler"
					(clickEv)="modalProps = { name: 'scheduler' }"
				/>
				<app-btn-ext
					text="send_invite"
					(clickEv)="modalProps = { name: 'invite-contactways' }"
				/>
				<!-- <app-btn-ext text="whatsapp" (clickEv)="sendInviteWa()" /> -->

				<app-btn-ext
					text="confirm"
					(clickEv)="save()"
					[disabled]="!isFormSubmittable"
					[isSpin]="isSaving"
				/>
			}

			<!-- TODO add close_download_btn -->
			@if (inUserPatientMode) {
				<app-btn-ext
					text="close_btn"
					[disabled]="!isFormSubmittable"
					(clickEv)="saveUserPatient()"
				/>
			}
		</div>
	</div>
}

<ng-template
	#rowFields
	let-test="test"
	let-patient="patient"
>
	<h4 class="followup-title">
		{{ test.name }} - {{ patient?.name }}

		@if (test.short_name) {
			<h4>({{ test.short_name }})</h4>
		}
	</h4>
	<!--  <h4 >{{'please_fill' | langVal}}</h4>-->
	<!-- <h4 lang v="please_fill"   ></h4> -->
	<div
		style="font-size: 18px; font-weight: 600; color: var(--black-lite)"
		class="d-grid gap-2"
	>
		<div
			[innerHTML]="test.description ? (test.description | safeHtml) : ''"
		></div>
		<div [innerHTML]="test.remarks ? (test.remarks | safeHtml) : ''"></div>
	</div>

	@for (tq of test.questions; track tq) {
		<div class="d-flex flex-nowrap pt-4 pb-2">
			@if (tq?.required == "yes") {
				*&nbsp;
			}
			<div
				class="fw-bold"
				[innerHTML]="tq.question | safeHtml"
			></div>
		</div>

		@if (tq.field_type !== "remark") {
			<div class="answer">
				@switch (tq.field_type) {
					@case ("text") {
						<app-gen-input
							fieldName="answer"
							type="textarea"
							[actualObj]="tq"
							(keyupEvent)="validateEntireForm()"
							(changeEvent)="validateEntireForm()"
						/>
					}
					@case ("number") {
						<app-gen-input
							fieldName="answer"
							[min]="tq.range_min"
							[max]="tq.range_max"
							[actualObj]="tq"
							(keyupEvent)="validateEntireForm()"
							(changeEvent)="validateEntireForm()"
							isNumber
						/>
					}
					@case ("opts-select") {
						<!-- <app-gen-select hasNone  [actualObj]="tq"  fieldName="answer"  (changeEvent)="tq.answer=opt.mark;validateEntireForm()" [errors]="tq.errors" [options]="tq.optionsArr" /> -->
					}
					@case ("opts-checkbox") {
						<div
							class="d-grid gap-2"
							style="padding: 0 7px"
						>
							@for (opt of tq.optionsArr; track opt) {
								<p class="d-flex flex-nowrap align-items-start gap-2">
									<input
										type="radio"
										[name]="'tq_' + tq.id"
										(click)="onCheck(tq, opt)"
										[checked]="tq.answer == opt.value"
									/>
									{{ opt.value }}
								</p>
							}
						</div>
					}
					@case ("multiple-choice") {
						<div
							class="d-grid gap-2"
							style="padding: 0 7px"
						>
							<multi
								[options]="tq.optionsArr"
								[value]="tq.answer"
								(onChange)="tq.answer = $event; validateEntireForm()"
							/>
						</div>
					}
					@case ("opts-btn-group") {
						<app-gen-button-group
							[actualObj]="tq"
							fieldName="answer"
							optionFieldValue="value"
							optionFieldName="value"
							[options]="tq.optionsArr"
							(changeEvent)="onBtnGroupClick(tq)"
						/>
					}
				}
			</div>
		}
		@if (tq.errors?.answer) {
			<p class="error">{{ tq.errors?.answer }}</p>
		}
	}
</ng-template>
@switch (modalProps?.name) {
	@case ("scheduler") {
		<app-modal-wrap
			(onClose)="onClose.emit(true)"
			title="create_scheduler"
		>
			<app-test-scheduler
				(onClose)="onClose.emit(true)"
				[patient_id]="patient.id"
				[test_id]="test_id"
			/>
		</app-modal-wrap>
	}
	@case ("invite-contactways") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-800"
		>
			<app-gen-table-display
				(onClose)="modalProps = null; $event?.length && send_invite($event)"
				tableName="contactways"
				filterField="patient_id"
				[filterFieldValue]="patient.id"
				fieldNameInItemToDisplay="contactway"
				chooseOnlyOne
				[filterFieldOrs]="{ contactway_identifier: ['email', 'phone'] }"
			/>
		</app-modal-wrap>
	}
}
